import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';


const CardManageOperatingRoomUX = (props: any) => {
    return(
      <div
        id="CardManageOperatingRoomUX-div-0"
        style={{display: "flex", height: "100%"}}>
        <div
          id="CardManageOperatingRoomUX-div-1"
          style={{flex: 1}}>

          <div
            id="CardManageOperatingRoomUX-div-3"
            style={{width: "100%"}}>
            {props.LocationElement}
          </div>
        </div>
        <div
          id="CardManageOperatingRoomUX-div-2"
          style={{flex: 3, padding: "1rem ", height: "calc(100dvh - 80px)"}}>

          <div
            id="CardManageOperatingRoomUX-div-5"
            style={{marginBottom: "1rem"}}>
            {`${props.title || ""}`}
          </div>
          <div
            id="CardManageOperatingRoomUX-div-6"
            style={{width: "100%", height: "100%"}}>
            {props.selectCalendar}
          </div>
        </div>
      </div>
    )
}


export default CardManageOperatingRoomUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 17:45:47 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardManageOperatingRoomUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardManageOperatingRoomUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardManageOperatingRoomUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3, padding: \"1rem \", height: \"calc(100dvh - 80px)\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.LocationElement"
        },
        "id": {
          "type": "value",
          "value": "CardManageOperatingRoomUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.title || \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardManageOperatingRoomUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"1rem\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectCalendar"
        },
        "id": {
          "type": "value",
          "value": "CardManageOperatingRoomUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\"}"
        }
      },
      "seq": 6,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardManageOperatingRoomUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
